// Anzeige-Helfer für „Sonstige Kontakte“ (Handoff Sonstige Kontakte §1/§2).
import type { KontaktUnified } from './types';

/** Anzahl der Avatar-Verläufe (Token --sk-av-0 … --sk-av-5 in styles/kontakte.css). */
export const AVATAR_FARBEN = 6;

export interface AvatarFarbe {
  index: number;
  /** Verlauf für den Avatar */
  verlauf: string;
  /** Grundfarbe (Schatten, Wasserzeichen) */
  farbe: string;
  /** zarter Farbschein oben rechts auf der Kachel */
  schein: (anteil: number) => string;
}

/** Stabile Farbe je id (Hash wie im Prototyp: h = h * 31 + Zeichen). */
export function avatarFarbe(id: string): AvatarFarbe {
  let h = 0;
  for (const ch of id) h = (h * 31 + ch.charCodeAt(0)) >>> 0;
  const i = h % AVATAR_FARBEN;
  const farbe = `var(--sk-av-${i}-b)`;
  return {
    index: i,
    verlauf: `linear-gradient(155deg, var(--sk-av-${i}-a), var(--sk-av-${i}-b))`,
    farbe,
    schein: (anteil: number) => `color-mix(in srgb, ${farbe} ${Math.round(anteil * 100)}%, transparent)`,
  };
}

/** Initialen wie bisher in der Kontaktliste: die ersten zwei Zeichen. */
export function kontaktInitialen(name: string): string {
  const n = name.trim();
  return n ? n.substring(0, 2).toUpperCase() : '?';
}

/** Unterzeile: sub_info (für Sonstige leer) bzw. typ_label (Kontaktart/Unternehmensart). */
export function kontaktUnterzeile(k: Pick<KontaktUnified, 'sub_info' | 'typ_label'>): string | null {
  return k.sub_info?.trim() || k.typ_label?.trim() || null;
}

export function kontakteAnzahl(n: number): string {
  return n === 1 ? '1 Kontakt' : `${n} Kontakte`;
}
